import Axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { APP_COOKIE_NAME, LOGOUT, SHOW_NOTIFICATION } from "../constants";
import { deleteCookie, getCookie, setCookie } from "../utils";

export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://daybyday-api.app.elingenierojefe.es"
    : "http://localhost:3005";

export const axios = Axios.create({ baseURL: BASE_URL });

const AUTH_ENDPOINTS = ["/user/login", "/user/check2FA"];

const isAuthEndpoint = (url = "") =>
  AUTH_ENDPOINTS.some((endpoint) => url.includes(endpoint));

const setAccessToken = async (token) => {
  axios.defaults.headers.common = {
    Authorization: `Bearer ${token || getCookie(APP_COOKIE_NAME)}`,
  };
  setCookie(APP_COOKIE_NAME, token, 1);
};

const chcekAccessToken = async (request) => {
  if (request.headers["Authorization"]) {
    return request;
  }

  const token = await getCookie(APP_COOKIE_NAME);
  if (token) {
    setAccessToken(token);
    return { ...request, headers: { Authorization: `Bearer ${token}` } };
  }

  return request;
};

const ConnectionHandler = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const showNotification = (message = "HA OCURRIDO UN ERROR") => {
      dispatch({
        type: SHOW_NOTIFICATION,
        payload: { show: true, status: "error", message },
      });
    };

    const exitFromApp = () => {
      deleteCookie(APP_COOKIE_NAME);
      dispatch({ type: LOGOUT });
    };

    const requestInterceptor = axios.interceptors.request.use(
      async (request) => {
        const config = await chcekAccessToken(request);
        return config;
      },
      (err) => {
        showNotification(err?.response?.data?.message || err?.message);
        return Promise.reject(err);
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        const requestUrl = response?.config?.url || "";
        if (isAuthEndpoint(requestUrl) && response?.data?.access_token) {
          setAccessToken(response.data.access_token);
        }
        return response;
      },
      (err) => {
        const status = err?.response?.status ?? 0;
        const message = err?.response?.data?.message || err?.message || "";
        const url = err?.config?.url || err?.response?.config?.url || "";
        const authRequest = isAuthEndpoint(url);

        console.log("RESPONSE ERROR (Target) => ", url);
        console.log("RESPONSE ERROR (Message) => ", message);
        console.log("RESPONSE ERROR (Code) => ", status);
        console.log("-----------------------------");

        if (authRequest) {
          return status || err;
        }

        switch (status) {
          case 401:
            if (message !== "Invalid token" && message) {
              showNotification(`${message}`);
            }
            exitFromApp();
            return status;
          case 300:
            return status;
          default:
            showNotification(message || "HA OCURRIDO UN ERROR");
            return status || err;
        }
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch]);

  return null;
};

export default ConnectionHandler;
